<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Dedication</span></p>
<p class="P_WFP_BodyText__And__Centre_Alignment__And__Left_Indent"><span>To FLORA ALLEN DRURY – 1894-1973</span></p>
<p class="P_WFP_BodyText__And__Centre_Alignment__And__Left_Indent"><span> </span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>Here lies a heart,</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>Dead not half a year;</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>I shan’t defile her grave</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>With half a tear.</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>I would, instead, recall</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>The many times she paced</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>This ground to meet</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>Her love’s embrace …</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>Remember her smiles,</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>Easily won …</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>Remember how her hair</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>Shone in the sun …</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>Remember how great beauty</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>Brought her tears …</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>Remember that she loved me</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment__And__Left_Indent"><span>Many years.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0005.vue?106914a4